export default "/images/shopping-bag-icon.svg?8bcdff10acbe76f5dfed39a7c815ad21";